import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
  makeStyles,
  CardActions,
  Link,
} from "@material-ui/core";
import { KeyboardArrowRight, Star } from "@material-ui/icons";
import React from "react";

const useStyle = makeStyles({
  body1: {
    fontSize: "16px",
  },
  body2: {
    fontSize: "18px",
  },
});

export function Rankings(props) {
  const { data } = props;
  const preventDefault = (event) => event.preventDefault();

  const rankingData = {
    collegeName: data.name,
    bestCollegeForNursing: data.rankingsBestCollegesForNursing,
    bestCollegeAthletics: data.rankingsBestCollegeAthletics,
    bestCollegeCampuses: data.rankingsBestCollegeCampuses,
  };
  const classes = useStyle();
  return (
    <Card className="pt-5 px-5">
      <CardHeader title="Rankings"></CardHeader>
      <CardContent>
        <Grid container alignContent="center">
          <Grid item sm={1} className="text-center">
            <Star style={{ color: "#93c4ff", fontSize: "32px" }}></Star>
          </Grid>
          <Grid item sm className="mr-18">
            <Typography variant="h4" color="primary" className="mb-3">
              {rankingData.collegeName + " Rankings"}
            </Typography>
            <Typography
              variant="body1"
              classes={{ body1: classes.body1 }}
              className="mb-5"
            >
              College Search Website rankings are based on rigorous analysis of
              key statistics from the U.S. Department of Education and millions
              of reviews.
            </Typography>
            <div className="d-flex justify-content-between">
              <div>
                <Typography variant="h6" color="primary">
                  Best College for Nursing
                </Typography>
                <Typography variant="h6" color="initial">
                  {rankingData.bestCollegeForNursing
                    ? "#" +
                      rankingData.bestCollegeForNursing.value +
                      " of " +
                      rankingData.bestCollegeForNursing.total
                    : "--"}
                </Typography>
              </div>
              <div>
                <Typography variant="h6" color="primary">
                  Best College Athletics
                </Typography>
                <Typography variant="h6" color="initial">
                  {rankingData.bestCollegeAthletics
                    ? "#" +
                      rankingData.bestCollegeAthletics.value +
                      " of " +
                      rankingData.bestCollegeAthletics.total
                    : "--"}
                </Typography>
              </div>
              <div>
                <Typography variant="h6" color="primary">
                  Best College Campuses
                </Typography>
                <Typography variant="h6" color="initial">
                  {rankingData.bestCollegeCampuses
                    ? "#" +
                      rankingData.bestCollegeCampuses.value +
                      " of " +
                      rankingData.bestCollegeCampuses.total
                    : "--"}
                </Typography>
              </div>
            </div>
          </Grid>
        </Grid>
      </CardContent>
      <hr className="mb-0" />
      <CardActions>
        <Typography variant="body1" color="primary" className="ml-auto mr-2">
          <Link
            href={window.location.href + "/rankings"}
            onLClick={preventDefault}
          >
            See all San Diego State University Rankings <KeyboardArrowRight />
          </Link>
        </Typography>
      </CardActions>
    </Card>
  );
}
